export interface AudioVideoModel {
  Intro: string;
  Title: string;
  LeftSections: AudioVideoSection[];
  RightSections: AudioVideoSection[];
}

export interface AudioVideoSection {
  Title: string;
  Header: string;
  Subcategories: AudioVideoSubcategory[];
}

export interface AudioVideoSubcategory {
  Name: string;
  Type: AudioVideoSubcategoryTypeEnum;
  Link: string;
  LinkName: string;
  Description: string;
  TrackFilePaths: string[];
}

export enum AudioVideoSubcategoryTypeEnum {
  NotSet = '',
  Audio = 'audio',
  Video = 'video',
}


